import { Layout } from '@/components/layout/Layout';
import { Copy } from 'lucide-react';

export function Settings() {
  return (
    <Layout breadcrumbs={[{ label: 'Home', path: '/' }, { label: 'Configurações' }]}>
      <div className="p-3 sm:p-4 lg:p-8">
        <div className="flex flex-col gap-4 lg:gap-8">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <p className="text-2xl sm:text-3xl font-bold tracking-tight text-text-title">Configurações</p>
          </div>

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8 lg:items-start">
            {/* Column 1 */}
            <div className="flex w-full flex-col gap-8">
              {/* General Settings Card */}
              <div className="rounded-xl border border-border bg-card shadow-sm">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-text-title">Configurações Gerais</h2>
                  <p className="mt-1 text-sm text-text-secondary">Atualize o nome, logo e timezone do seu sistema.</p>
                </div>
                <div className="flex flex-col gap-4 border-t border-border p-6">
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="system-name">
                      Nome do sistema
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="system-name"
                      type="text"
                      defaultValue="CURRAL TECH"
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary">Logo do sistema</label>
                    <div className="flex items-center gap-4">
                      <img src="/logo.png" alt="Logo" className="h-16 w-16 rounded-lg object-contain" />
                      <input
                        className="block w-full text-sm text-text-secondary file:mr-4 file:rounded-lg file:border-0 file:px-4 file:py-2 file:text-sm file:font-semibold file:bg-[rgba(0,62,107,0.1)] file:text-[#003E6B] hover:file:bg-muted"
                        id="logo-upload"
                        type="file"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="timezone">
                      Timezone padrão
                    </label>
                    <select
                      className="form-select w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="timezone"
                    >
                      <option>(GMT-03:00) America/Sao_Paulo</option>
                      <option>(GMT-05:00) Eastern Time (US & Canada)</option>
                      <option>(GMT+00:00) Coordinated Universal Time</option>
                    </select>
                  </div>
                </div>
                <div className="flex justify-end rounded-b-xl border-t border-border bg-muted/50 p-4">
                  <button className="flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg px-6 text-sm font-bold text-white" style={{ backgroundColor: '#003E6B' }}>
                    Salvar Alterações
                  </button>
                </div>
              </div>

              {/* Notifications Card */}
              <div className="rounded-xl border border-border bg-card shadow-sm">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-text-title">Notificações</h2>
                  <p className="mt-1 text-sm text-text-secondary">Configure como e quando você recebe alertas.</p>
                </div>
                <div className="flex flex-col gap-4 border-t border-border p-6">
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="alert-email">
                      Email para alertas críticos
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="alert-email"
                      type="email"
                      defaultValue="admin@curral.tech"
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="telegram-token">
                      Telegram bot token <span className="text-xs text-text-hint">(opcional)</span>
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="telegram-token"
                      placeholder="123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11"
                      type="text"
                    />
                  </div>
                  <div className="space-y-2 pt-2">
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary">Configurar quando alertar</label>
                    <div className="relative flex items-start">
                      <div className="flex h-6 items-center">
                        <input
                          defaultChecked
                          className="form-checkbox h-4 w-4 rounded border-border-strong focus:ring-primary/50"
                          style={{ color: '#003E6B' }}
                          id="critical-error"
                          type="checkbox"
                        />
                      </div>
                      <div className="ml-3 text-sm leading-6">
                        <label className="font-medium text-text-title" htmlFor="critical-error">
                          Erro crítico
                        </label>
                      </div>
                    </div>
                    <div className="relative flex items-start">
                      <div className="flex h-6 items-center">
                        <input
                          defaultChecked
                          className="form-checkbox h-4 w-4 rounded border-border-strong focus:ring-primary/50"
                          style={{ color: '#003E6B' }}
                          id="device-offline"
                          type="checkbox"
                        />
                      </div>
                      <div className="ml-3 text-sm leading-6">
                        <label className="font-medium text-text-title" htmlFor="device-offline">
                          Dispositivo offline
                        </label>
                      </div>
                    </div>
                    <div className="relative flex items-start">
                      <div className="flex h-6 items-center">
                        <input className="form-checkbox h-4 w-4 rounded border-border-strong focus:ring-primary/50" style={{ color: '#003E6B' }} id="new-user" type="checkbox" />
                      </div>
                      <div className="ml-3 text-sm leading-6">
                        <label className="font-medium text-text-title" htmlFor="new-user">
                          Novo usuário cadastrado
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end rounded-b-xl border-t border-border bg-muted/50 p-4">
                  <button className="flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg px-6 text-sm font-bold text-white" style={{ backgroundColor: '#003E6B' }}>
                    Salvar Alterações
                  </button>
                </div>
              </div>

              {/* API & Webhooks Card */}
              <div className="rounded-xl border border-border bg-card shadow-sm">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-text-title">API & Webhooks</h2>
                  <p className="mt-1 text-sm text-text-secondary">Gerencie suas chaves de API e endpoints.</p>
                </div>
                <div className="flex flex-col gap-4 border-t border-border p-6">
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="api-key">
                      API Key
                    </label>
                    <div className="relative">
                      <input
                        className="form-input w-full rounded-lg border-border-strong bg-muted pr-12 font-mono text-xs text-text-secondary focus:border-primary focus:ring-primary/50"
                        id="api-key"
                        readOnly
                        type="text"
                        defaultValue="CT-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                      />
                      <button className="absolute inset-y-0 right-0 flex items-center justify-center rounded-r-lg px-3 text-text-secondary hover:bg-gray-200">
                        <Copy size={16} />
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="webhooks">
                      Webhook endpoints customizados
                    </label>
                    <textarea
                      className="form-textarea w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="webhooks"
                      placeholder="https://example.com/webhook/new-device&#10;https://example.com/webhook/critical-error"
                      rows={3}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="rate-limit">
                      Rate limiting (requests/min)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="rate-limit"
                      type="number"
                      defaultValue={120}
                    />
                  </div>
                </div>
                <div className="flex justify-end rounded-b-xl border-t border-border bg-muted/50 p-4">
                  <button className="flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg px-6 text-sm font-bold text-white" style={{ backgroundColor: '#003E6B' }}>
                    Salvar Alterações
                  </button>
                </div>
              </div>
            </div>

            {/* Column 2 */}
            <div className="flex w-full flex-col gap-8">
              {/* Authentication Card */}
              <div className="rounded-xl border border-border bg-card shadow-sm">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-text-title">Autenticação</h2>
                  <p className="mt-1 text-sm text-text-secondary">Defina as políticas de sessão e login para os usuários.</p>
                </div>
                <div className="flex flex-col gap-4 border-t border-border p-6">
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="otp-duration">
                      Duração do OTP (minutos)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="otp-duration"
                      type="number"
                      defaultValue={15}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="otp-attempts">
                      Tentativas máximas de OTP
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="otp-attempts"
                      type="number"
                      defaultValue={3}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="jwt-duration">
                      Duração da sessão JWT (dias)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="jwt-duration"
                      type="number"
                      defaultValue={30}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="n8n-webhook">
                      Webhook N8N (URL para envio de OTP)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="n8n-webhook"
                      type="text"
                      defaultValue="https://n8n.curral.tech/webhook/send-otp"
                    />
                    <div className="mt-2 flex items-center gap-2">
                      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-online"></span>
                      <p className="text-xs font-medium" style={{ color: '#4CAF50' }}>Status de integração: Conectado</p>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end rounded-b-xl border-t border-border bg-muted/50 p-4">
                  <button className="flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg px-6 text-sm font-bold text-white" style={{ backgroundColor: '#003E6B' }}>
                    Salvar Alterações
                  </button>
                </div>
              </div>

              {/* Data Retention Card */}
              <div className="rounded-xl border border-border bg-card shadow-sm">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-text-title">Retenção de Dados</h2>
                  <p className="mt-1 text-sm text-text-secondary">Gerencie por quanto tempo os dados são mantidos no sistema.</p>
                </div>
                <div className="flex flex-col gap-4 border-t border-border p-6">
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="logs-retention">
                      Logs (manter por X dias)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="logs-retention"
                      type="number"
                      defaultValue={90}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="errors-retention">
                      Erros resolvidos (manter por X dias)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="errors-retention"
                      type="number"
                      defaultValue={180}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="sessions-retention">
                      Sessões expiradas (manter por X dias)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="sessions-retention"
                      type="number"
                      defaultValue={30}
                    />
                  </div>
                  <div>
                    <label className="mb-1.5 block text-sm font-medium text-text-secondary" htmlFor="offline-devices-retention">
                      Dispositivos offline (marcar como inativo após X dias)
                    </label>
                    <input
                      className="form-input w-full rounded-lg border-border-strong bg-card text-text-title focus:border-primary focus:ring-primary/50"
                      id="offline-devices-retention"
                      type="number"
                      defaultValue={60}
                    />
                  </div>
                </div>
                <div className="flex justify-end rounded-b-xl border-t border-border bg-muted/50 p-4">
                  <button className="flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg px-6 text-sm font-bold text-white" style={{ backgroundColor: '#003E6B' }}>
                    Salvar Alterações
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
